<template>
  <section class="section container pt-3">
    <div class="mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("identity module settings") }}
      </h1>
    </div>

    <div class="columns mt-5">
      <div class="column">
        <h1 class="title is-5">{{ $t("drive module integration") }}</h1>
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_integrate_drive"
            name="chk_integrate_drive"
            v-model="meta.integrate_drive"
          />
          <label for="chk_integrate_drive">{{ $t("integrate") }}</label>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('drive')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/drive/catalog"
            name_field="name"
            value_field="drive_id"
            @selected="drive_changed"
            ref="drive_dropdown"
          />
        </div>
      </div>
    </div>

    <div class="columns mt-5">
      <!-- <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('script for document analysis')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/script/catalog"
            name_field="name"
            value_field="directory"
            @selected="crop_script_changed"
            ref="crop_script_dropdown"
          />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('face detection script')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/script/catalog"
            name_field="name"
            value_field="directory"
            @selected="face_script_changed"
            ref="face_script_dropdown"
          />
        </div>
      </div> -->
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('renap profile')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/renap/profile/catalog"
            name_field="name"
            value_field="profile_id"
            @selected="renap_profile_changed"
            ref="renap_profile_dropdown"
          />
        </div>
      </div>
    </div>

    <!-- <div class="columns mt-5">
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('script for face analysis')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/script/catalog"
            name_field="name"
            value_field="directory"
            @selected="face_comparisson_script_changed"
            ref="face_comparisson_script_dropdown"
          />
        </div>
      </div>
      <div class="column"></div>
    </div> -->

    <div class="container mt-6">
      <div class="field mt-5">
        <div class="control">
          <button class="button is-rounded is-primary" @click="save">
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  success_message,
  error_message,
  change_active_tab,
} from "@/utils";
import { isEmpty } from "lodash";
import { v4 } from "uuid";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
// import ProcessesDatatable from "./processes_datatable/Index.vue";

export default {
  name: "OnfidoSettings",
  components: {
    GenericDropdown,
    /* ProcessesDatatable */
  },
  data() {
    return {
      meta: { profiles: [] },
    };
  },
  methods: {
    change_active_tab,
    save() {
      let v = this;
      let data = { ...v.meta };
      v.$root.loader(true);
      save_configuration(v, data)
        .then(() => {
          success_message(v.$t("configuration saved"));
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    drive_changed(selected) {
      let v = this;
      if (selected) v.meta.drive_id = selected.drive_id;
    },
    crop_script_changed(selected) {
      let v = this;
      if (selected) v.meta.crop_script = selected.directory;
    },
    face_script_changed(selected) {
      let v = this;
      if (selected) v.meta.face_script = selected.directory;
    },
    renap_profile_changed(selected) {
      let v = this;
      if (selected) v.meta.renap_profile_id = selected.profile_id;
    },
    face_comparisson_script_changed(selected) {
      let v = this;
      if (selected) v.meta.face_comparisson_script = selected.directory;
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        if (conf && !isEmpty(conf)) v.meta = conf;

        if (conf && conf.drive_id)
          v.$refs.drive_dropdown.set_value(conf.drive_id);
        if (conf && conf.renap_profile_id)
          v.$refs.renap_profile_dropdown.set_value(conf.renap_profile_id);

        // if (conf && conf.crop_script)
        //   v.$refs.crop_script_dropdown.set_value(conf.crop_script);
        // if (conf && conf.face_script)
        //   v.$refs.face_script_dropdown.set_value(conf.face_script);
        // if (conf && conf.face_comparisson_script)
        //   v.$refs.face_comparisson_script_dropdown.set_value(
        //     conf.face_comparisson_script
        //   );
      })
      .catch((error) => {
        error_message(error);
      })
      .finally(() => {
        v.$root.loader(false);
      });
  },
};
</script>

<style></style>
